import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCollapsedMenuTitle } from "../modules";
var useAppSelector = useSelector;
var useAppDispatch = function() {
    return useDispatch();
};
export var useMenu = function() {
    var dispatch = useAppDispatch();
    var collapsedTitle = useAppSelector(function(param) {
        var menu = param.menu;
        return menu;
    }).collapsedTitle;
    var setCollapsedTitle = useCallback(function(title) {
        dispatch(setCollapsedMenuTitle(title));
    }, [
        dispatch
    ]);
    return {
        collapsedTitle: collapsedTitle,
        setCollapsedTitle: setCollapsedTitle
    };
};

//# sourceMappingURL=useMenu.js.map